import React, { Component } from "react";
import { get as _get, isEmpty as _isEmpty } from "lodash";
import { FormattedMessage, injectIntl } from "react-intl";
import { Dropdown, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

import { RenderTableCellValue, RenderTableHeaderValue, showAlertMessage, ShowContentLoader, Select, ConfirmBox } from "../../resusableComponents/common/formElements";
import ReactDataTable from "../../resusableComponents/common/ReactDataTable";
import { withRouter } from "../../resusableComponents/hoc/withRouter";

import CreateNewClient from "../Admin/UserManagement/component/Client/CreateNewClient";

import { updateLoadingState } from "../../redux/actions/application";

import { getCompetitiveAnalysisList, deleteCompetitiveAnalysis, getCompetitiveAnalysisCron, saveCompetitiveAnalysis } from "../../redux/services/competitiveAnalysis";
import { doGetClientNameList } from "../../redux/services/campaignSetup";

const MAX_COMPETITORS = 10;

const LINKEDIN_REGEX = /^https?:\/\/(www\.)?linkedin\.com\/.+/i;

const _getEmptyCompetitor = () => ({ client_name: "", linkedin_url: "" });

class CompetitiveAnalysis extends Component {
  constructor(props) {
    super(props);

    const { intl } = props;

    this.state = {
      // list
      clientNameList: [],
      analysisList: [],
      totalRecords: 0,
      showTableLoader: true,
      listPayload: {
        page_no: 1,
        page_size: 10,
        orderby: "id",
        order: "desc"
      },

      // add / edit form
      showAddForm: false,
      isEditMode: false,
      editAnalysisId: null,
      selectedClient: null,
      linkedinUrl: "",
      competitors: [_getEmptyCompetitor()],
      formErrors: {},

      // delete confirm
      showDeleteConfirmBox: false,
      selectedAnalysis: {},

      // add client modal
      showAddClientModal: false,
    };

    this.tableColumns = [
      {
        name: (<RenderTableHeaderValue value={intl.formatMessage({ id: "competitive_analysis.table.id", defaultMessage: "ID" })} />),
        selector: (row) => _get(row, "id", ""),
        cell: (row) => (<RenderTableCellValue className="text-truncate" value={_get(row, "id", "")} tooltip={false} />),
        sortable: true,
        id: "id",
        width: "80px"
      },
      {
        name: (<RenderTableHeaderValue value={intl.formatMessage({ id: "competitive_analysis.table.client_name", defaultMessage: "Client Name" })} />),
        selector: (row) => _get(row, "client_name", ""),
        cell: (row) => (<RenderTableCellValue className="text-truncate" value={_get(row, "client_name", "")} tooltip={true} />),
        sortable: false,
        id: "client_name",
        grow: 1
      },
      {
        name: (<RenderTableHeaderValue value={intl.formatMessage({ id: "competitive_analysis.table.competitive_client_list", defaultMessage: "Competitive Clients" })} />),
        selector: (row) => _get(row, "competitive_client_list", ""),
        cell: (row) => (<RenderTableCellValue className="text-truncate" value={_get(row, "competitive_client_list", "")} tooltip={true} />),
        sortable: false,
        id: "competitive_client_list",
        grow: 2
      },
      {
        name: (<RenderTableHeaderValue value={intl.formatMessage({ id: "competitive_analysis.table.start_date", defaultMessage: "Start Date" })} />),
        selector: (row) => _get(row, "start_date", ""),
        cell: (row) => (<RenderTableCellValue className="text-truncate" value={_get(row, "start_date", "")} tooltip={true} />),
        sortable: true,
        id: "start_date",
        grow: 1
      },
      {
        name: (<RenderTableHeaderValue value={intl.formatMessage({ id: "competitive_analysis.table.end_date", defaultMessage: "End Date" })} />),
        selector: (row) => _get(row, "end_date", ""),
        cell: (row) => (<RenderTableCellValue className="text-truncate" value={_get(row, "end_date", "")} tooltip={true} />),
        sortable: true,
        id: "end_date",
        grow: 1
      },
      {
        name: (<RenderTableHeaderValue value={intl.formatMessage({ id: "competitive_analysis.table.report_date", defaultMessage: "Report Date" })} />),
        selector: (row) => _get(row, "report_date", ""),
        cell: (row) => (<RenderTableCellValue className="text-truncate" value={_get(row, "report_date", "")} tooltip={true} />),
        sortable: true,
        id: "report_date",
        grow: 1
      },
      {
        name: (<RenderTableHeaderValue value={intl.formatMessage({ id: "competitive_analysis.table.created_by", defaultMessage: "Created By" })} />),
        selector: (row) => _get(row, "created_by", ""),
        cell: (row) => (<RenderTableCellValue className="text-truncate" value={_get(row, "created_by", "")} tooltip={true} />),
        sortable: true,
        id: "created_by",
        grow: 1
      },
      {
        name: (<RenderTableHeaderValue value={intl.formatMessage({ id: "competitive_analysis.table.action", defaultMessage: "Action" })} />),
        sortable: false,
        width: "80px",
        center: "true",
        cell: (row) => (
          <Dropdown>
            <Dropdown.Toggle as="a" variant="link" className="fw-normal dropdown-toggle-no cursor-pointer">
              <img src={require("../../assets/icons/icon-three-dot.svg").default} className="img-fluid" alt="actions" />
            </Dropdown.Toggle>
            <Dropdown.Menu as="ul" className="dropdown-menu">
              <Link
                to={`/analysis/view-competitive-analysis-report/${_get(row, "id", "")}`}
                className="dropdown-item d-flex align-items-center gap-2 waves-effect text-capitalize"
              >
                <FormattedMessage id="competitive_analysis.action.view" defaultMessage="View" />
              </Link>
              <Dropdown.Item
                className="dropdown-item d-flex align-items-center gap-2 waves-effect text-capitalize"
                onClick={() => this._fetchCompetitiveAnalysisCron(row)}
              >
                <FormattedMessage id="competitive_analysis.action.edit" defaultMessage="Edit" />
              </Dropdown.Item>
              <Dropdown.Item
                className="dropdown-item d-flex align-items-center gap-2 waves-effect text-capitalize text-danger"
                onClick={() => this.setState({ showDeleteConfirmBox: true, selectedAnalysis: row })}
              >
                <FormattedMessage id="competitive_analysis.action.delete" defaultMessage="Delete" />
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        )
      }
    ];
  }

  componentDidMount() {
    this._fetchClientNameList();
    this._fetchCompetitiveAnalysisList();
  }

  // ─── API calls ────────────────────────────────────────────────────────────────

  _fetchClientNameList = async () => {
    const { updateLoadingState } = this.props;

    try {
      if (typeof updateLoadingState === "function") { updateLoadingState(true); }

      const response = await doGetClientNameList({ agency_id: null, dropdown_flag: 1 });

      if (_get(response, "flag", false) === true) {
        this.setState({ clientNameList: _get(response, "data.responseData.client_list", []) });
      } else {
        showAlertMessage(_get(response, "message", "Something went wrong while fetching client name list."));
      }
    } catch (err) {
      showAlertMessage(_get(err, "message", "Something went wrong while fetching client name list."));
    } finally {
      if (typeof updateLoadingState === "function") { updateLoadingState(false); }
    }
  }

  _handleClientCreated = () => {
    // Close the modal and refresh the client dropdown
    this.setState({ showAddClientModal: false });
    this._fetchClientNameList();
  }

  _fetchCompetitiveAnalysisList = async () => {
    const { updateLoadingState, intl } = this.props;
    const { listPayload } = this.state;

    try {
      if (typeof updateLoadingState === "function") { updateLoadingState(true); }
      this.setState({ showTableLoader: true });

      const response = await getCompetitiveAnalysisList(listPayload);

      if (_get(response, "flag", false) === true) {
        this.setState({
          showTableLoader: false,
          analysisList: _get(response, "data.competitive_analysis", []),
          totalRecords: _get(response, "data.page_info[0].total_records", 0)
        });
      } else {
        showAlertMessage(_get(response, "message", intl.formatMessage({ id: "competitive_analysis.error.fetch_list", defaultMessage: "Something went wrong while fetching competitive analysis list." })));
        this.setState({ showTableLoader: false, analysisList: [] });
      }
    } catch (err) {
      showAlertMessage(_get(err, "message", intl.formatMessage({ id: "competitive_analysis.error.fetch_list", defaultMessage: "Something went wrong while fetching competitive analysis list." })));
      this.setState({ showTableLoader: false, analysisList: [] });
    } finally {
      if (typeof updateLoadingState === "function") { updateLoadingState(false); }
    }
  }

  _fetchCompetitiveAnalysisCron = async (row) => {
    const { updateLoadingState, intl } = this.props;
    const { clientNameList } = this.state;

    const analysisId = _get(row, "id", null);

    try {
      if (typeof updateLoadingState === "function") { updateLoadingState(true); }

      const response = await getCompetitiveAnalysisCron(analysisId);

      if (_get(response, "flag", false) === true) {
        const clientDetail = _get(response, "data.competitive_analysis[0]", {});
        const clientCompetition = _get(response, "data.competitive_client_detail", []);

        // Match the client from the dropdown list by client_id
        const matchedClient = (clientNameList || []).find(
          (c) => _get(c, "id", null) === _get(clientDetail, "client_id", null)
        ) || null;

        // Map competitors from the API response
        const mappedCompetitors = (clientCompetition || []).map((comp) => ({
          competitive_analysis_detail_id: _get(comp, "competitive_analysis_detail_id", null),
          client_name: _get(comp, "client_name", ""),
          linkedin_url: _get(comp, "linkedin_url", "")
        }));

        this.setState({
          isEditMode: true,
          editAnalysisId: analysisId,
          selectedAnalysis: row,
          selectedClient: matchedClient,
          linkedinUrl: _get(clientDetail, "linkedin_url", ""),
          competitors: mappedCompetitors.length > 0 ? mappedCompetitors : [_getEmptyCompetitor()],
          formErrors: {},
          showAddForm: true
        });
      } else {
        showAlertMessage(_get(response, "message", intl.formatMessage({ id: "competitive_analysis.error.fetch_cron", defaultMessage: "Something went wrong while fetching competitive analysis details." })));
      }
    } catch (err) {
      showAlertMessage(_get(err, "message", intl.formatMessage({ id: "competitive_analysis.error.fetch_cron", defaultMessage: "Something went wrong while fetching competitive analysis details." })));
    } finally {
      if (typeof updateLoadingState === "function") { updateLoadingState(false); }
    }
  }

  _saveCompetitiveAnalysis = async () => {
    const { updateLoadingState, intl } = this.props;
    const { selectedClient, linkedinUrl, competitors/*, isEditMode, editAnalysisId*/ } = this.state;

    if (!this._validateForm()) { return; }

    const savePayload = {
      client_name: _get(selectedClient, "client_name", ""),
      client_id: _get(selectedClient, "id", 0),
      linkedin_url: linkedinUrl,
      competitive_client_json: (competitors || []).map((c) => ({
        client_name: _get(c, "client_name", ""),
        linkedin_url: _get(c, "linkedin_url", "")
      })),
      //start_date: "",
      //end_date: "",
      //delete_flag: false,
    };

    // Include the ID when editing an existing record
    /*if (isEditMode && editAnalysisId) {
      savePayload.competitive_analysis_id = editAnalysisId;
    }*/

    try {
      if (typeof updateLoadingState === "function") { updateLoadingState(true); }

      const response = await saveCompetitiveAnalysis(savePayload);

      if (_get(response, "flag", false) === true) {
        showAlertMessage(_get(response, "message", intl.formatMessage({ id: "competitive_analysis.success.save", defaultMessage: "Analysis saved successfully." })), "success");
        this._resetForm();
        this._fetchCompetitiveAnalysisList();
      } else {
        showAlertMessage(_get(response, "message", intl.formatMessage({ id: "competitive_analysis.error.save", defaultMessage: "Something went wrong while saving analysis." })));
      }
    } catch (err) {
      showAlertMessage(_get(err, "message", intl.formatMessage({ id: "competitive_analysis.error.save", defaultMessage: "Something went wrong while saving analysis." })));
    } finally {
      if (typeof updateLoadingState === "function") { updateLoadingState(false); }
    }
  }

  _deleteCompetitiveAnalysis = async () => {
    const { updateLoadingState, intl } = this.props;
    const { selectedAnalysis } = this.state;

    const analysisId = _get(selectedAnalysis, "id", 0);

    try {
      if (typeof updateLoadingState === "function") { updateLoadingState(true); }

      const response = await deleteCompetitiveAnalysis(analysisId);

      if (_get(response, "flag", false) === true) {
        showAlertMessage(_get(response, "message", intl.formatMessage({ id: "competitive_analysis.success.delete", defaultMessage: "Analysis deleted successfully." })), "success");
        this.setState({ selectedAnalysis: {}, showDeleteConfirmBox: false });
        this._fetchCompetitiveAnalysisList();
      } else {
        showAlertMessage(_get(response, "message", intl.formatMessage({ id: "competitive_analysis.error.delete", defaultMessage: "Something went wrong while deleting analysis." })));
        this.setState({ selectedAnalysis: {}, showDeleteConfirmBox: false });
      }
    } catch (err) {
      showAlertMessage(_get(err, "message", intl.formatMessage({ id: "competitive_analysis.error.delete", defaultMessage: "Something went wrong while deleting analysis." })));
      this.setState({ selectedAnalysis: {}, showDeleteConfirmBox: false });
    } finally {
      if (typeof updateLoadingState === "function") { updateLoadingState(false); }
    }
  }

  handlePaginationChange = (pageNo) => {
    const { listPayload } = this.state;

    this.setState({ listPayload: { ...listPayload, page_no: pageNo } }, () => {
      this._fetchCompetitiveAnalysisList();
    });
  }

  handleSortChange = (column, sortDirection) => {
    const { listPayload } = this.state;

    this.setState({
      listPayload: { ...listPayload, orderby: _get(column, "id", "id"), order: sortDirection, page_no: 1 }
    }, () => {
      this._fetchCompetitiveAnalysisList();
    });
  }

  // ─── Form helpers ─────────────────────────────────────────────────────────────

  _validateLinkedinUrl = (url) => {
    return !_isEmpty((url || "").trim()) && LINKEDIN_REGEX.test((url || "").trim());
  }

  _validateForm = () => {
    const { intl } = this.props;
    const { selectedClient, linkedinUrl, competitors } = this.state;
    const errors = {};

    // Client required
    if (_isEmpty(selectedClient)) {
      errors.selectedClient = intl.formatMessage({ id: "competitive_analysis.error.client_required", defaultMessage: "Please select a client." });
    }

    // LI URL required + domain validation
    if (_isEmpty((linkedinUrl || "").trim())) {
      errors.linkedinUrl = intl.formatMessage({ id: "competitive_analysis.error.linkedin_url_required", defaultMessage: "Please enter the LinkedIn URL." });
    } else if (!this._validateLinkedinUrl(linkedinUrl)) {
      errors.linkedinUrl = intl.formatMessage({ id: "competitive_analysis.error.linkedin_url_invalid", defaultMessage: "Please enter a valid LinkedIn URL." });
    }

    // At least one competitor required
    if (_isEmpty(competitors)) {
      errors.competitors = intl.formatMessage({ id: "competitive_analysis.error.competitor_required", defaultMessage: "At least one competitor is required." });
    } else {
      const competitorErrors = (competitors || []).map((c, idx) => {
        const rowErr = {};
        if (_isEmpty((_get(c, "client_name", "")).trim())) {
          rowErr.client_name = intl.formatMessage({ id: "competitive_analysis.error.competitor_name_required", defaultMessage: "Competitor name is required." });
        }
        const liUrl = (_get(c, "linkedin_url", "")).trim();
        if (_isEmpty(liUrl)) {
          rowErr.linkedin_url = intl.formatMessage({ id: "competitive_analysis.error.competitor_linkedin_url_required", defaultMessage: "Competitor LinkedIn URL is required." });
        } else if (!this._validateLinkedinUrl(liUrl)) {
          rowErr.linkedin_url = intl.formatMessage({ id: "competitive_analysis.error.competitor_linkedin_url_invalid", defaultMessage: "Please enter a valid LinkedIn URL for competitor." });
        }
        return rowErr;
      });

      const hasCompetitorErrors = competitorErrors.some((e) => !_isEmpty(e));
      if (hasCompetitorErrors) {
        errors.competitorRows = competitorErrors;
      }
    }

    this.setState({ formErrors: errors });
    return _isEmpty(errors);
  }

  _resetForm = () => {
    this.setState({
      showAddForm: false,
      isEditMode: false,
      editAnalysisId: null,
      selectedClient: null,
      linkedinUrl: "",
      competitors: [_getEmptyCompetitor()],
      formErrors: {}
    });
  }

  _handleAddReport = () => {
    this.setState((prev) => ({ showAddForm: !prev.showAddForm, formErrors: {} }));
  }

  _handleCompetitorChange = (index, field, value) => {
    this.setState((prev) => {
      const updated = (prev.competitors || []).map((c, i) =>
        i === index ? { ...c, [field]: value } : c
      );
      return { competitors: updated };
    });
  }

  _handleAddCompetitorRow = () => {
    const { intl } = this.props;
    const { competitors } = this.state;

    if ((competitors || []).length >= MAX_COMPETITORS) {
      showAlertMessage(intl.formatMessage({ id: "competitive_analysis.error.max_competitors", defaultMessage: "You can add a maximum of 10 competitors." }));
      return;
    }
    this.setState((prev) => ({
      competitors: [...(prev.competitors || []), _getEmptyCompetitor()]
    }));
  }

  _handleDeleteCompetitorRow = (index) => {
    this.setState((prev) => ({
      competitors: (prev.competitors || []).filter((_, i) => i !== index)
    }));
  }

  // ─── Render helpers ───────────────────────────────────────────────────────────

  _renderAddReportForm = () => {
    const { intl } = this.props;
    const { clientNameList, selectedClient, linkedinUrl, competitors, formErrors, /*isEditMode,*/ showAddClientModal } = this.state;

    return (
      <div className="card mb-5">
        <div className="card-body py-5 px-6">

          {/* ── Section: Select Client ── */}
          <h6 className="fw-semibold text-dark-35 text-uppercase mb-4">
            <FormattedMessage id="competitive_analysis.form.section.select_client" defaultMessage="Select Client" />
          </h6>

          <div className="row gy-4 mb-5">
            {/* Client dropdown */}
            <div className="col-lg-4">
              <label className="form-label fw-medium">
                <FormattedMessage id="competitive_analysis.form.label.client" defaultMessage="Client" />
                <span className="text-danger ms-1">*</span>
              </label>
              <div className="d-flex align-items-center gap-2">
                <div className="flex-grow-1">
                  <Select
                    inputId="competitive-analysis-client-select"
                    className="form-custom-select"
                    placeholder={intl.formatMessage({ id: "competitive_analysis.form.placeholder.select_client", defaultMessage: "Select Client" })}
                    options={(clientNameList || [])}
                    value={(selectedClient || null)}
                    getOptionLabel={(option) => (_get(option, "client_name", ""))}
                    getOptionValue={(option) => (_get(option, "id", null))}
                    onChange={(selected) => this.setState({ selectedClient: selected, formErrors: { ...formErrors, selectedClient: undefined } })}
                    isMulti={false}
                  />
                </div>
                <button
                  id="btn-add-new-client"
                  type="button"
                  className="btn btn-outline-primary btn-sm waves-effect text-nowrap"
                  style={{ marginTop: "2px" }}
                  onClick={() => this.setState({ showAddClientModal: true })}
                  title={intl.formatMessage({ id: "competitive_analysis.btn.add_client", defaultMessage: "Add Client" })}
                >
                  + <FormattedMessage id="competitive_analysis.btn.add_client" defaultMessage="Add Client" />
                </button>
              </div>
              {_get(formErrors, "selectedClient") && (
                <div className="text-danger small mt-1">{_get(formErrors, "selectedClient", "")}</div>
              )}
            </div>

            {/* Add Client Modal */}
            <Modal
              show={(showAddClientModal || false)}
              onHide={() => this.setState({ showAddClientModal: false })}
              size="lg"
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title className="fw-semibold text-dark-35">
                  <FormattedMessage id="competitive_analysis.modal.add_client_title" defaultMessage="Add New Client" />
                </Modal.Title>
              </Modal.Header>
              <Modal.Body className="p-4">
                <CreateNewClient
                  skipAccessCheck={true}
                  onClientCreated={this._handleClientCreated}
                />
              </Modal.Body>
            </Modal>

            {/* LI URL */}
            <div className="col-lg-4">
              <label className="form-label fw-medium">
                <FormattedMessage id="competitive_analysis.form.label.linkedin_url" defaultMessage="LI URL (LinkedIn URL)" />
                <span className="text-danger ms-1">*</span>
              </label>
              <input
                id="competitive-analysis-linkedin-url"
                type="text"
                className={`form-control${_get(formErrors, "linkedinUrl") ? " is-invalid" : ""}`}
                placeholder={intl.formatMessage({ id: "competitive_analysis.form.placeholder.linkedin_url", defaultMessage: "https://www.linkedin.com/company/..." })}
                value={(linkedinUrl || "")}
                onChange={(e) => this.setState({ linkedinUrl: e.target.value, formErrors: { ...formErrors, linkedinUrl: undefined } })}
              />
              {_get(formErrors, "linkedinUrl") && (
                <div className="invalid-feedback">{_get(formErrors, "linkedinUrl", "")}</div>
              )}
            </div>
          </div>

          <hr className="my-4" />

          {/* ── Section: Competitor Selection ── */}
          <h6 className="fw-semibold text-dark-35 text-uppercase mb-4">
            <FormattedMessage id="competitive_analysis.form.section.competitor_selection" defaultMessage="Competitor Selection" />
          </h6>

          {_get(formErrors, "competitors") && (
            <div className="text-danger small mb-3">{_get(formErrors, "competitors", "")}</div>
          )}

          {/* Competitor header row */}
          <div className="row gx-3 mb-2 d-none d-lg-flex">
            <div className="col-lg-4">
              <span className="form-label fw-medium mb-0">
                <FormattedMessage id="competitive_analysis.form.label.competitor_name" defaultMessage="Name" />
                <span className="text-danger ms-1">*</span>
              </span>
            </div>
            <div className="col-lg-5">
              <span className="form-label fw-medium mb-0">
                <FormattedMessage id="competitive_analysis.form.label.linkedin_url" defaultMessage="LI URL (LinkedIn URL)" />
                <span className="text-danger ms-1">*</span>
              </span>
            </div>
          </div>

          {/* Competitor rows */}
          {(competitors || []).map((competitor, index) => {
            const rowErrors = _get(formErrors, `competitorRows[${index}]`, _get(formErrors, `competitorRows.${index}`, {}));
            return (
              <div key={index} className="row gx-3 mb-3 align-items-start">
                <div className="col-lg-4">
                  <input
                    id={`competitor-name-${index}`}
                    type="text"
                    className={`form-control${_get(rowErrors, "client_name") ? " is-invalid" : ""}`}
                    placeholder={intl.formatMessage({ id: "competitive_analysis.form.placeholder.competitor_name", defaultMessage: "Enter competitor name" })}
                    value={(_get(competitor, "client_name", ""))}
                    onChange={(e) => this._handleCompetitorChange(index, "client_name", e.target.value)}
                  />
                  {_get(rowErrors, "client_name") && (
                    <div className="invalid-feedback">{_get(rowErrors, "client_name", "")}</div>
                  )}
                </div>

                <div className="col-lg-5">
                  <input
                    id={`competitor-linkedin-url-${index}`}
                    type="text"
                    className={`form-control${_get(rowErrors, "linkedin_url") ? " is-invalid" : ""}`}
                    placeholder={intl.formatMessage({ id: "competitive_analysis.form.placeholder.competitor_linkedin_url", defaultMessage: "https://www.linkedin.com/company/..." })}
                    value={(_get(competitor, "linkedin_url", ""))}
                    onChange={(e) => this._handleCompetitorChange(index, "linkedin_url", e.target.value)}
                  />
                  {_get(rowErrors, "linkedin_url") && (
                    <div className="invalid-feedback">{_get(rowErrors, "linkedin_url", "")}</div>
                  )}
                </div>

                <div className="col-lg-3 d-flex align-items-start pt-1">
                  <button
                    id={`btn-delete-competitor-${index}`}
                    type="button"
                    className="btn btn-outline-danger btn-sm waves-effect"
                    onClick={() => this._handleDeleteCompetitorRow(index)}
                  >
                    <FormattedMessage id="competitive_analysis.form.btn.delete_row" defaultMessage="Delete" />
                  </button>
                </div>
              </div>
            );
          })}

          {/* Add More */}
          {(competitors || []).length < MAX_COMPETITORS && (
            <div className="mb-4">
              <button
                id="btn-add-more-competitor"
                type="button"
                className="btn btn-link p-0 text-primary fw-medium"
                onClick={this._handleAddCompetitorRow}
              >
                <FormattedMessage id="competitive_analysis.btn.add_more" defaultMessage="+ Add More" />
              </button>
            </div>
          )}

          <hr className="my-4" />

          {/* Form action buttons */}
          <div className="d-flex gap-3">
            <button
              id="btn-generate-report"
              type="button"
              className="btn btn-primary waves-effect"
              onClick={this._saveCompetitiveAnalysis}
            >
              <FormattedMessage id="competitive_analysis.btn.generate_report" defaultMessage="Generate Report" />
            </button>
            <button
              id="btn-cancel-add-report"
              type="button"
              className="btn btn-outline-secondary waves-effect"
              onClick={this._resetForm}
            >
              <FormattedMessage id="competitive_analysis.btn.cancel" defaultMessage="Cancel" />
            </button>
          </div>

        </div>
      </div>
    );
  }

  render() {
    const { intl } = this.props;
    const { showTableLoader, analysisList, totalRecords, showAddForm, /*isEditMode,*/ showDeleteConfirmBox } = this.state;

    return (
      <>
        <div className="container-fluid flex-grow-1 px-6 py-6">
          <div className="row">
            <div className="col-lg-12 d-flex align-items-center justify-content-between mb-5">
              <h1 className="heading-04 fw-semibold text-dark-35 text-uppercase mb-0">
                <FormattedMessage id="competitive_analysis.title" defaultMessage="Competitive Analysis" />
              </h1>
              <button
                id="btn-add-competitive-analysis-report"
                className="btn btn-primary waves-effect"
                onClick={this._handleAddReport}
              >
                <FormattedMessage id="competitive_analysis.btn.add_report" defaultMessage="Add Report" />
              </button>
            </div>

            {/* Expandable Add Report Form */}
            {showAddForm && this._renderAddReportForm()}

            {/* Analysis List Table */}
            <div className="row mt-5">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-body py-5">
                    <div className="table-responsive custom-scroll">
                      <ReactDataTable
                        className="custom-scroll-460"
                        columns={this.tableColumns}
                        data={(analysisList || [])}
                        progressPending={showTableLoader}
                        progressComponent={<ShowContentLoader />}
                        pagination={true}
                        totalRecords={(totalRecords || 0)}
                        onChangePage={(pageNo) => this.handlePaginationChange(pageNo)}
                        onSort={(column, sortDirection) => this.handleSortChange(column, sortDirection)}
                        sortServer={true}
                        defaultSortFieldId="id"
                        defaultSortAsc={false}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ConfirmBox
          isOpen={(showDeleteConfirmBox || false)}
          onConfirm={() => this._deleteCompetitiveAnalysis()}
          onClose={() => this.setState({ showDeleteConfirmBox: false, selectedAnalysis: {} })}
          content={intl.formatMessage({ id: "competitive_analysis.confirm.delete", defaultMessage: "Are you sure you want to delete this analysis report?" })}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
  updateLoadingState: (data) => dispatch(updateLoadingState(data))
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(CompetitiveAnalysis)));
